export const States = [
  "Alaska",
  "Alabama",
  "Arkansas",
  "American Samoa",
  "Arizona",
  "California",
  "Colorado",
  "Connecticut",
  "District of Columbia",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Iowa",
  "Idaho",
  "Illinois",
  "Indiana",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Massachusetts",
  "Maryland",
  "Maine",
  "Michigan",
  "Minnesota",
  "Missouri",
  "Mississippi",
  "Montana",
  "North Carolina",
  "North Dakota",
  "Nebraska",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "Nevada",
  "New York",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Virgin Islands",
  "Vermont",
  "Washington",
  "Wisconsin",
  "West Virginia",
  "Wyoming",
];

// Base URLs from environment variables
export const BASE_URL = import.meta.env.VITE_BASE_URL ;

/**
 * Canonical public marketing origin for ticket/product/share links.
 * Use when the app runs on staging (e.g. idolcodesource) but links must point at production.
 */
export const PUBLIC_SITE_URL = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined)?.trim() ?? "";
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const STRIPE_PUBLISHABLE_KEY = (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? "";
export const INSTAGRAM_URL =
  import.meta.env.VITE_INSTAGRAM_URL ?? "https://www.instagram.com";
export const FACEBOOK_URL = import.meta.env.VITE_FACEBOOK_BASE_URL ?? "";
export const YOUTUBE_URL =
  import.meta.env.VITE_YOUTUBE_BASE_URL ?? "https://www.youtube.com";
export const TIKTOK_URL = import.meta.env.VITE_TIKTOK_BASE_URL ?? "";
export const LINKEDIN_URL = import.meta.env.VITE_LINKEDIN_BASE_URL ?? "";
export const COMEDYUO_INSTAGRAM_URL = "https://www.instagram.com/comedy.uo/";
export const COMEDYUO_YOUTUBE_URL = "https://www.youtube.com/@ComedyUO";
export const COMEDYUO_EMAIL = "admin@comedyuo.com";

/** Homepage hero (Katz's Deli) — cropped to 1200×630 for link previews. */
export const DEFAULT_OG_IMAGE_PATH = "/images/og-default-katz-deli.jpg";

export function absolutePublicUrl(path: string): string {
  const origin = (PUBLIC_SITE_URL || BASE_URL || "https://comedyuo.com").replace(
    /\/$/,
    "",
  );
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}

export const DEFAULT_OG_IMAGE_URL = absolutePublicUrl(DEFAULT_OG_IMAGE_PATH);

// Page Routes
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  PRESS: "/press",
  NEWSLETTER: "/newsletter",
  FAQ: "/faq",
  CONTACT: "/contact",
  PRIVATE_EVENTS: "/private-events",
  PRIVATE_ENTERTAINMENT: "/sc-holdings",
  WORK_WITH_US: "/work-with-us",
  WAITLIST: "/waitlist",
  TICKETS: "/tickets",
  MAGIC: "/magic",
  GALLERY: "/gallery",
  CART: "/cart",
  CHECKOUT: "/checkout",
  QUEUE: "/queue",
  COMEDYUO:"/comedyuo",
} as const;

// Canonical public URLs (comedyuo.com), not the Firebase preview origin.
export const NAVIGATION_URLS = {
  HOME: absolutePublicUrl(PAGE_ROUTES.HOME),
  ABOUT: absolutePublicUrl(PAGE_ROUTES.ABOUT),
  PRESS: absolutePublicUrl(PAGE_ROUTES.PRESS),
  NEWSLETTER: absolutePublicUrl(PAGE_ROUTES.NEWSLETTER),
  FAQ: absolutePublicUrl(PAGE_ROUTES.FAQ),
  CONTACT: absolutePublicUrl(PAGE_ROUTES.CONTACT),
  PRIVATE_EVENTS: absolutePublicUrl(PAGE_ROUTES.PRIVATE_EVENTS),
  WORK_WITH_US: absolutePublicUrl(PAGE_ROUTES.WORK_WITH_US),
  TICKETS: absolutePublicUrl(PAGE_ROUTES.TICKETS),
  MAGIC: absolutePublicUrl(PAGE_ROUTES.MAGIC),
  GALLERY: absolutePublicUrl(PAGE_ROUTES.GALLERY),
  CART: absolutePublicUrl(PAGE_ROUTES.CART),
  INSTAGRAM:  `${INSTAGRAM_URL}`,
  INSTACOMEDYUO:`${INSTAGRAM_URL}${PAGE_ROUTES.COMEDYUO}`,
  FACEBOOKCOMEDYUO:`${FACEBOOK_URL}${PAGE_ROUTES.COMEDYUO}`,
  YOUTUBE: `${YOUTUBE_URL}`,
  TIKTOK: `${TIKTOK_URL}`,
  LINKEDIN: `${LINKEDIN_URL}`,
} as const;
export const SHOWTYPES = ["comedy", "magic"];

export function getShowTypeColor(type: string) {
  return type == "comedy" ? "#4063d5" : "#f2aa23ff";
}

/** Ticket-page brand above the title. Default Comedy UO; Magic UO if title/description mentions magic. */
export function getBrandLabel(opts?: {
  title?: string | null;
  description?: string | null;
}): string {
  const text = `${opts?.title ?? ""} ${opts?.description ?? ""}`.toLowerCase();
  return /\bmagic\b/.test(text) ? "Magic UO" : "Comedy UO";
}
